import React from "react"
export function FPH(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M18.167 5.311c.46 0 .833.373.833.834v12.849h-2.89v-5.04h-2.167v5.04h-9.39v-5.648c0-.46.373-.833.833-.833h5.668V6.144c0-.46.373-.834.833-.834h6.28zM7.804 13.955H5.998v1.8h1.806v-1.8zm3.248 0H9.247v1.8h1.805v-1.8zm6.507-3.961h-1.806v1.8h1.806v-1.8zm-3.251-.002h-1.806v1.8h1.806v-1.8zm-.002-3.237H12.5v1.8h1.806v-1.8zm3.252-.002h-1.806v1.8h1.806v-1.8zm-6.153-5.376a.816.816 0 01-.26 1.124l-1.373.858-.015.008-6.7 4.187-2.056-2.062.394-.246a.5.5 0 01.37-.065l.092.03 1.108.474 2.68-1.675-2.773-2.12.84-.525a.5.5 0 01.34-.07l.087.02 3.765 1.283 2.376-1.48a.816.816 0 011.125.259z"
        fill="currentColor"
        id="prefix__FPH"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
